import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

// MD3 assist/status chip. `default` uses the primary tonal container so
// it reads as an accent, not an alert; status-mapping variants keep their
// own hues (see StatusBadge) since they carry semantic meaning.
const badgeVariants = cva(
  "inline-flex items-center whitespace-nowrap rounded-full border px-3 py-1 text-xs font-medium transition-colors",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary-container text-primary-on-container",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        success:
          "border-transparent bg-success-container text-success-on-container",
        warning:
          "border-transparent bg-warning-container text-warning-on-container",
        destructive:
          "border-transparent bg-destructive-container text-destructive-on-container",
        outline: "border-outline text-foreground",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { badgeVariants };
